const nameSpacedEvents = {};
const generateEventId = () =>
  `${`${Date.now()}`.slice(-8)}_${Math.random() * 1e10}`.replace(".", "");
const addEvent = (el, type, handler, options = {}) => {
  const [ev, namespace] = type.split(".");
  nameSpacedEvents[`${ev}_${namespace}`] = handler;

  if (el.attachEvent) {
    el.attachEvent(`on${ev}`, handler);
  } else {
    el.addEventListener(ev, handler, options);
  }
};

const hashEmail = (email) => {
  const encoder = new TextEncoder();
  const data = encoder.encode(email);
  return crypto.subtle.digest("SHA-256", data).then((hash) => {
    return Array.from(new Uint8Array(hash))
      .map((b) => b.toString(16).padStart(2, "0"))
      .join("");
  });
};

const acuityAnalytics = ({
  appointmentType = "",
  email = "",
  bookingID = "",
}) => {
  if (typeof window.dataLayer === "undefined") window.dataLayer = [];
  const uniqueEventID = generateEventId();
  let value = 0;
  if (/suit/i.test(appointmentType)) value = 3800;
  if (/virtual/i.test(appointmentType)) value = 3200;
  if (/shirt/i.test(appointmentType)) value = 700;

  hashEmail(email).then((hashedEmail) => {
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push({
      event: "acuity_conversion",
      ecommerce: {
        "x-fb-event_id": uniqueEventID,
        appointment_type: appointmentType,
        transaction_id: bookingID,
        value,
        currency: "USD",
      },
      userEmailHash: hashedEmail,
    });
  });
};

addEvent(window, "message.acuityConversionListener", (m) => {
  if (m.origin === "https://conversion-tracking-sandbox.acuityinnovation.com") {
    // Conversion data sent from custom conversion acuity plugin.
    acuityAnalytics(m.data);
  }
});
